import { observable, action, makeObservable, runInAction } from 'mobx';
import {
    getTenantList,
    getSms,
    smsLogin,
    accountLogin,
    verifyFirst,
    verifySecond,
    getUserInfo,
    outLogin,
    mobileVerify,
    pwdVerify,
    pwdModify,
    moblieVerifyFirst,
    moblieVerifySecond,
    getAdminUserInfo,
    getTenantInfo,
    tenantSort,
    improveInfoDetail,
    tenantInfo,
    submitImproveInfo,
    thirdConfig,
    checkToken,
    fetchRegisteredStatus,
    getLoginAndOutGoPath,
    improveInfoDetailUndertake,
    submitImproveInfoUndertake,
    submitImproveInfoOrgids,
    submitImproveInfoByOrg,
    systemConfigGtByType,
    getLoginTabConfigReq,
    getAESKey,
    codeVerifyLogin,
    quickLogin
} from '../api/login';
import { updateCookie, clearCookie } from '../utils/index';
import message from '@/components/Toast';
import global from './global';
import { competition_constants } from '../utils/constants';
import { afterThirdLogin, studentAfterThirdLogin } from '@/page/Login/utils';
import { encryptAES } from '@/utils/index';

class Login {
    constructor() {
        makeObservable(this);
    }

    @observable
    settingMode = 'setting'; //setting,updateTel,updatePassword

    @action
    setSettingMode = (v) => {
        this.settingMode = v;
    };

    @observable switchTenant = false;

    @action
    setSwitchTenant = (v) => {
        this.switchTenant = v;
    };

    @observable
    mode = 'login'; //forget、codeVerify、login

    @action
    setMode = (v) => {
        this.mode = v;
    };

    @observable
    showTenantList = [];

    @action
    setShowTenantList = (v) => {
        this.showTenantList = v;
    };

    @observable
    key_word = '';

    @action
    setKeyWord = (v) => {
        this.key_word = v;
    };

    @observable informationVisible = false;

    @action
    setInformationVisible = (v) => {
        this.informationVisible = v;
    };

    @observable systemConfig = {};

    @action
    setSystemConfig = (v) => {
        this.systemConfig = v;
    };

    @observable
    redirectUrl = '';

    @action
    setRedirectUrl = (v) => {
        this.redirectUrl = v;
    };

    @observable activeIdentity = 'student'; //admin

    @action
    setActiveIdentity = (v) => {
        this.activeIdentity = v;
        if (v === 'admin') {
            this.showTenantList = this.key_word
                ? this.tenantList?.adminTenants?.filter((item) => {
                      return item.tenant_name.indexOf(this.key_word) > -1;
                  })
                : this.tenantList?.adminTenants || [];
        } else {
            this.showTenantList = this.key_word
                ? this.tenantList?.studentTenants?.filter((item) => {
                      return item.tenant_name.indexOf(this.key_word) > -1;
                  })
                : this.tenantList?.studentTenants || [];
        }
    };

    @observable
    tenantList = { adminTenants: [], studentTenants: [] };

    fetchList = async () => {
        const { data, code, msg } = await getTenantList();

        if (code === '00000') {
            runInAction(() => {
                this.tenantList = data;
                this.showTenantList = this.activeIdentity === 'admin' ? data.adminTenants : data.studentTenants;
            });
        } else {
            return message.error(msg);
        }
    };
    //获取配置的登录跳转的url
    goConfigLoginUrl = async () => {
        let url = await afterThirdLogin();
        console.log(url, '跳转的url');
        if (url) {
            window.location.href = url;
        }
    };
    loginCallback = async (loginInfo, type) => {
        if (loginInfo) {
            updateCookie(Object.assign(loginInfo, { domain: window.location.host }));
        }
        // 启航杯大赛`
        if (type === 'competition') {
            if (this.redirectUrl) {
                window.location.href = this.redirectUrl;
                return;
            }
            if (this.qhbMode === 'city') {
                return (window.location.href = `https://${window.location.host}/web/tenant/${competition_constants.business_id}`);
            }
            return (window.location.href = `https://${window.location.host}/web/tenant/${this.regionId}?type=region`);
        }

        if (this.redirectUrl) {
            window.location.href = this.redirectUrl;
            return;
        }

        const { code, data } = await getTenantList();

        if (code === '00000') {
            for (let i = 0; i < data?.studentTenants.length; i++) {
                if (data.studentTenants[i].domain === window.location.host && !data.studentTenants[i].state) {
                    updateCookie(data.studentTenants[i]);
                    const url = await studentAfterThirdLogin();
                    return (window.location.href = url);
                }
            }
            window.location.href = '/';
        }
    };

    @observable captchaVisible = false;

    @action
    setCaptchaVisible = (v) => {
        this.captchaVisible = v;
    };

    @observable activeKey = 'code'; //password

    @action
    setActiveKey = (v) => {
        this.activeKey = v;
    };

    getSmn = async (params) => {
        const { code, msg } = await getSms(params);

        if (code === '00000') {
            if (params.types === 2) {
                message.success('请注意接听来电');
            }
            return true;
        } else if (code === 'A0123') {
            this.setCaptchaVisible(true);
        } else {
            message.error(msg);
            return false;
        }
    };

    // 完善信息
    @observable improve_info = {};

    @action
    setImproveInfo(info) {
        this.improve_info = info;
    }

    @observable auth_token = {};

    @action
    setAuthToken(info) {
        this.auth_token = info;
    }

    @observable isRegister = {};

    @action
    setIsRegister(flag) {
        this.isRegister = flag;
    }

    @observable orgIdsArr = [];

    @action
    setOrgIdsArr(orgIds) {
        this.orgIdsArr = orgIds;
    }

    // 获取学员完善信息
    improveInfoDetail = async (form, isRegister) => {
        this.setAuthToken(form);
        const { msg, code, data } = await improveInfoDetail(form);
        if (code === '00000') {
            this.setImproveInfo(data);
            this.setIsRegister(isRegister);
            this.setInformationVisible(true);
        } else {
            return message.error(msg);
        }
    };

    // 学员完善信息提交
    submitImproveInfo = async (form) => {
        let formData = form;
        //后端需求 如果this.improve_info?.field_value 返回single_orgId_value则提交的时候再传给后端
        if (this.improve_info?.field_value?.single_orgId_value) {
            formData.single_orgId_value = this.improve_info?.field_value?.single_orgId_value;
        }
        let Fun =
            this.systemConfig?.student_application_type === 1
                ? submitImproveInfoUndertake({ ...formData, ...this.auth_token })
                : submitImproveInfo({ ...formData, ...this.auth_token });
        const { msg, code, data } = await Fun;
        if (code === '00000') {
            this.setInformationVisible(false);
            this.quickLogin({ login_token: data });
        } else {
            return message.error(msg);
        }
    };
    //学员承培通过组织ID查询承接方学生完善信息
    improveInfoDetailByOrg = async (id) => {
        const { msg, code, data } = await submitImproveInfoByOrg(id);
        if (code === '00000') {
            let improve_info = this.improve_info,
                infoNew = [...improve_info?.field_keyNew, ...(data?.field_key || [])];
            improve_info.field_key = infoNew;
            this.setImproveInfo(improve_info);
        } else {
            return message.error(msg);
        }
    };

    improveInfoDetailUndertakeData = async (fun, isRegister) => {
        const { msg, code, data } = await improveInfoDetailUndertake(fun);
        if (code === '00000') {
            data.field_keyNew = data.field_key;
            this.setImproveInfo(data);
            this.setIsRegister(isRegister);
            this.setInformationVisible(true);
        } else {
            return message.error(msg);
        }
    };
    // 获取项目组织ID
    submitImproveInfoOrgidsFun = async () => {
        let getSearchParams = this.getSearchParams();
        if (getSearchParams?.business_id && getSearchParams?.template_id === '104') {
            const res = await submitImproveInfoOrgids(getSearchParams?.business_id);
            if (res.code === '00000') {
                this.setOrgIdsArr(res.data);
            } else {
                return message.error(res.msg);
            }
        }
    };

    // 获取承培学员完善信息
    improveInfoDetailUndertake = async (form, isRegister) => {
        this.setAuthToken(form);
        let getSearchParams = this.getSearchParams();
        if (getSearchParams?.business_id && getSearchParams?.template_id === '104') {
            this.improveInfoDetailUndertakeData({ ...form, org_ids_by_undertake: this.orgIdsArr }, isRegister);
        } else {
            this.improveInfoDetailUndertakeData({ ...form }, isRegister);
        }
    };
    //根据类型查询租户配置-公开
    systemConfigGtByTypeFun = async (form, isRegister) => {
        const { msg, code, data } = await systemConfigGtByType({ type: 'student_application_type' });
        if (code === '00000') {
            this.setSystemConfig(data);
            // student_application_type 1 承培 2 自培
            if (data.student_application_type === 1) {
                this.improveInfoDetailUndertake(form, isRegister);
            } else {
                this.improveInfoDetail(form, isRegister);
            }
        } else {
            return message.error(msg);
        }
    };

    //获取参数
    getQueryVariable = (name) => {
        const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'),
            result = window.location.search.substr(1).match(reg);
        if (result) return decodeURIComponent(result[2]);
        return null;
    };
    getSearchParams = () => {
        let redirect = this.getQueryVariable('redirect');
        if (!redirect) return null;

        const urlRedirect = new URL(redirect);
        let searchParamsObject = {
            template_id: urlRedirect.searchParams.get('template_id'),
            business_id: this.getQueryVariable('business_id'),
            publiclyInviteStuType: this.getQueryVariable('publiclyInviteStuType'),
            publiclyInviteStuFrom: this.getQueryVariable('publiclyInviteStuFrom')
        };

        return searchParamsObject;
    };

    smsLogin = async (params, type) => {
        //如果是公共邀请学员多传3个参数type template_id business_id
        let getSearchParams = this.getSearchParams();
        if (getSearchParams?.publiclyInviteStuFrom === 'publiclyInviteStuFrom' && getSearchParams?.publiclyInviteStuType === '2') {
            params.type = getSearchParams?.publiclyInviteStuType;
            params.template_id = getSearchParams?.template_id;
            params.business_id = getSearchParams?.business_id;
        }
        if (this.orgIdsArr && this.orgIdsArr?.length) {
            params.org_ids = this.orgIdsArr;
        }
        const { code, msg, data, stack_trace } = await smsLogin(params, type);
        params.auth_token = stack_trace;
        if (code === '00000') {
            this.loginCallback(data, type);
        } else if (code === 'A0142') {
            this.systemConfigGtByTypeFun({ auth_token: stack_trace }, false);
        } else if (code === 'A0143') {
            //补全信息逻辑
            this.systemConfigGtByTypeFun({ auth_token: stack_trace }, false);
        } else {
            return message.error(msg);
        }
    };

    codeVerifyLogin = async (params) => {
        params.multi_factor_verify_token = this.codeVerifyToken;
        const { code, msg, data } = await codeVerifyLogin(params);

        if (code === '00000') {
            await this.loginCallback(data);
        } else if (code === 'A0163') {
            //多因子 token 过期
            message.error(msg);
            this.setCodeVerifyToken('');
            this.setMode('login');
            return;
        } else {
            return message.error(msg);
        }
    };

    //多因子校验token
    @observable codeVerifyToken = '';
    @action
    setCodeVerifyToken = (v) => {
        this.codeVerifyToken = v;
    };

    accountLogin = async (params, type) => {
        let getSearchParams = this.getSearchParams();
        if (getSearchParams?.publiclyInviteStuFrom === 'publiclyInviteStuFrom' && getSearchParams?.publiclyInviteStuType === '2') {
            params.type = getSearchParams?.publiclyInviteStuType;
            params.template_id = getSearchParams?.template_id;
            params.business_id = getSearchParams?.business_id;
        }
        if (this.orgIdsArr && this.orgIdsArr?.length) {
            params.org_ids = this.orgIdsArr;
        }
        const aesKeyRes = await getAESKey();
        if (aesKeyRes.code === '00000') {
            params.password = encryptAES(params.password, aesKeyRes.data.aes_key);
            params.aes_key_id = aesKeyRes.data.aes_key_id;
        } else {
            return message.error(aesKeyRes.msg || '服务请求发生错误');
        }

        const { code, msg, data, stack_trace } = await accountLogin(params, type);
        params.auth_token = stack_trace;
        if (code === '00000') {
            this.loginCallback(data, type);
        } else if (code === 'A0123') {
            this.setCaptchaVisible(true);
        } else if (code === 'A0142') {
            this.systemConfigGtByTypeFun({ auth_token: stack_trace }, false);
        } else if (code === 'A0143') {
            //自主注册账号需要完善信息
            this.systemConfigGtByTypeFun({ auth_token: stack_trace }, false);
        } else if (code === 'A0162') {
            //多因子 验证码校验
            this.setMode('codeVerify');
            this.setCodeVerifyToken(stack_trace);
        } else {
            return message.error(msg);
        }
    };

    //快速登录
    quickLogin = async (params) => {
        const { code, msg, data } = await quickLogin(params);
        if (code === '00000') {
            this.loginCallback(data);
        } else {
            return message.error(msg);
        }
    };

    // 忘记密码

    @observable forgetStep = 1;
    @observable verify_token = '';

    @action
    setForgetStep = (v) => {
        this.forgetStep = v;
    };

    verifyFirst = async (params) => {
        const { code, data, msg } = await verifyFirst(params);

        if (code === '00000') {
            runInAction(() => {
                this.forgetStep = 2;
                this.verify_token = data.verify_token;
            });
            return true;
        }
        message.error(msg);
        return false;
    };

    verifySecond = async (params) => {
        const aesKeyRes = await getAESKey();
        if (aesKeyRes.code === '00000') {
            params.pwd = encryptAES(params.pwd, aesKeyRes.data.aes_key);
            params.confirm_pwd = encryptAES(params.confirm_pwd, aesKeyRes.data.aes_key);
            params.aes_key_id = aesKeyRes.data.aes_key_id;
        } else {
            return message.error(aesKeyRes.msg || '服务请求发生错误');
        }

        const { code, msg } = await verifySecond(params);

        if (code === '00000') {
            runInAction(() => {
                this.mode = 'login';
                this.settingMode = 'setting';
            });
        } else {
            return message.error(msg);
        }
    };

    // 修改手机号

    @observable modifyMoblieStep = 1;
    @observable moblie_verify_token = '';

    @action
    setModifyMoblieStep = (v) => {
        this.modifyMoblieStep = v;
    };

    moblieVerifyFirst = async (params) => {
        const { code, data, msg } = await moblieVerifyFirst(params);

        if (code === '00000') {
            runInAction(() => {
                this.modifyMoblieStep = 2;
                this.moblie_verify_token = data.verify_token;
            });
            return true;
        }
        message.error(msg);
        return false;
    };

    moblieVerifySecond = async (params) => {
        const { code, msg } = await moblieVerifySecond(params);

        if (code === '00000') {
            runInAction(() => {
                this.modifyMoblieStep = 1;
                this.settingMode = 'setting';
            });
            await this.getUserInfo();
        } else {
            return message.error(msg);
        }
    };

    @observable userInfo = {};

    outLogin = async (params) => {
        const { code, msg } = await outLogin(params);
        let { logout_config = {} } = this.loginAndOutConfig,
            { logout_redirect_type = 0, can_logout = 0 } = logout_config,
            outUrl = '/login';
        if (code === '00000') {
            runInAction(() => {
                this.identityInfo = null;
            });
            clearCookie(window.location.host);
            if (logout_redirect_type === 1 && can_logout === 1) {
                //开启退出登录&&自定义退出登录页
                outUrl = this?.loginAndOutConfig?.logout_config?.pc;
            }
            window.location.href = outUrl;
        } else {
            return message.error(msg);
        }
    };

    //修改密码

    @observable modifyPwdStep = 1;
    @observable modifyPwdMode = 'code';
    @observable pwd_verify_token = '';

    @action
    setModifyPwdMode = (v) => {
        this.modifyPwdMode = v;
    };

    @action
    setModifyPwdStep = (v) => {
        this.modifyPwdStep = v;
    };

    mobileVerify = async (params) => {
        const { code, data, msg } = await mobileVerify(params);

        if (code === '00000') {
            runInAction(() => {
                this.modifyPwdStep = 2;
                this.pwd_verify_token = data.verify_token;
            });
        } else {
            return message.error(msg);
        }
    };

    pwdVerify = async (params) => {
        const aesKeyRes = await getAESKey();
        if (aesKeyRes.code === '00000') {
            params.pwd = encryptAES(params.pwd, aesKeyRes.data.aes_key);
            params.aes_key_id = aesKeyRes.data.aes_key_id;
        } else {
            return message.error(aesKeyRes.msg || '服务请求发生错误');
        }

        const { code, msg, data } = await pwdVerify(params);

        if (code === '00000') {
            runInAction(() => {
                this.modifyPwdStep = 2;
                this.pwd_verify_token = data.verify_token;
            });
        } else {
            return message.error(msg);
        }
    };

    pwdModify = async (params) => {
        const aesKeyRes = await getAESKey();
        if (aesKeyRes.code === '00000') {
            params.pwd = encryptAES(params.pwd, aesKeyRes.data.aes_key);
            params.confirm_pwd = encryptAES(params.confirm_pwd, aesKeyRes.data.aes_key);
            params.aes_key_id = aesKeyRes.data.aes_key_id;
        } else {
            return message.error(aesKeyRes.msg || '服务请求发生错误');
        }

        const { code, msg } = await pwdModify(params);

        if (code === '00000') {
            message.success('密码修改成功，请重新登录');
            clearCookie(window.location.host);
            window.location.href = '/login';
        } else {
            return message.error(msg);
        }
    };

    getUserInfo = async () => {
        const res = await getUserInfo();

        if (res.code === '00000') {
            runInAction(() => {
                this.userInfo.mobile = res.data.mobile;
            });
        } else {
            return message.error(res.msg);
        }
        return res;
    };

    //获取管理员信息
    getAdminUserInfo = async () => {
        const res = await getUserInfo();
        if (res.code === '00000') {
            runInAction(() => {
                this.userInfo = res.data || {};
            });
            const res2 = await getTenantInfo();

            if (res2.code === '00000') {
                runInAction(() => {
                    this.userInfo.tenantName = res2.data;
                    sessionStorage.setItem('tenantName', res2.data);
                });
            }
            const { code, msg, data } = await getAdminUserInfo({
                user_id: res.data?.id
            });

            if (code === '00000') {
                runInAction(() => {
                    this.userInfo.adminInfo = data;
                    global.setGlobalState({ userInfo: this.userInfo }); //传给子应用
                });
                return true;
            }
            if (code === 'A0400') {
                //无管理员身份
                this.userInfo.adminInfo = 1;
                return 1;
            }

            return message.error(msg);
        }
        return message.error(res.msg);
    };

    tenantSort = async (params) => {
        const { code, msg } = await tenantSort(params);

        if (code === '00000') {
            this.fetchList();
        } else {
            return message.error(msg);
        }
    };

    getLoginTabConfig = async (tenantInfo) => {
        let res = await getLoginTabConfigReq({ type: 'login_tabs_config' });
        if (res.success) {
            const loginTabConfig = res.data,
                shouldUsePortalTitle = !loginTabConfig || (loginTabConfig && loginTabConfig?.enable === 1);
            document.title = shouldUsePortalTitle ? tenantInfo?.name : '';
        } else {
            message.error(res.msg);
        }
    };

    @observable tenantInfo = { name: '' };
    //租户信息
    getCurTenantInfo = async () => {
        const res = await tenantInfo();
        if (res.code === '00000') {
            await this.getLoginTabConfig(res.data);
            runInAction(() => {
                this.tenantInfo = res.data;
            });
        } else {
            return message.error(res.msg);
        }
        return res;
    };

    @observable qhbMode = 'city'; //region

    @action
    setQhbMode = (v) => {
        this.qhbMode = v;
    };

    @observable regionId = ''; //region

    @action
    setQegionId = (v) => {
        this.regionId = v;
    };

    @observable
    loginAndOutConfig = {
        logout_config: {
            can_logout: 1,
            logout_redirect_type: 0
        }
    }; //登录退出配置
    //获取登录和退出配置，判断登录和退出成功后跳到哪里
    getLoginAndOutConfig = async () => {
        let res = await getLoginAndOutGoPath();
        if (res && res.code === '00000') {
            runInAction(() => {
                if (res.data && Object.keys(res.data).length) {
                    this.loginAndOutConfig = res.data;
                } else {
                    this.loginAndOutConfig = {
                        logout_config: {
                            can_logout: 1,
                            logout_redirect_type: 0
                        }
                    };
                }
            });
            return res.data;
        }
        message.error(res.msg || '');
        return false;
    };
    // 第三方配置
    @observable
    thirdConfig = {};

    getThirdConfig = async () => {
        const { code, msg, data } = await thirdConfig();
        if (code === '00000') {
            runInAction(() => {
                if (data) {
                    this.thirdConfig = data;
                } else {
                    this.thirdConfig = {
                        forbid_quit: false,
                        login_redirect: 1
                    };
                }
            });
        } else {
            return message.error(msg);
        }
    };

    //检查是否登录
    checkLogin = async () => {
        const { data } = await checkToken();
        return data;
    };

    @observable
    registeredStatus = false; //独立登录页自主注册开启状态 true:开启，false:未开启

    fetchRegisteredStatus = async () => {
        const { code, msg, data } = await fetchRegisteredStatus();
        if (code === '00000') {
            runInAction(() => {
                this.registeredStatus = data;
            });
        } else {
            return message.error(msg);
        }
    };
}

export default new Login();
